"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var store_component_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/store_component"));
var input_wrapper_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/input/input_wrapper"));
var MapNameInput = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement(input_wrapper_1.default, { store: store.inputStore },
        react_1.default.createElement(store_component_1.default, { store: store.inputStore })));
});
exports.default = MapNameInput;
